export default __webpack_public_path__ + "static/media/Hypertension-1.5591d196.jpg";